import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'asmpp_sensor_type',
  title: 'Модели датчиков АСМПП',
  apiType: apiTypes.REPORT_API,
  elemsOnPage: 100,
  connections: {},
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
      disableFilter: true
    },
    {
      name: 'name',
      title: 'Наименование модели',
      type: 'text',
      required: false,
      maxLengthValue: 255,
    },
    {
      name: 'shortName',
      title: 'Сокращённое обозначение',
      type: 'text',
      required: false,
      maxLengthValue: 50,
    },
  ],
  newTemplate: {
    id: null,
    model: null,
    shortName: null,
  },
  updateField: 'update_date',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'model',
        field: 'model',
      },
      {
        title: 'shortName',
        field: 'shortName',
      },
    ],
    example: `AAAA;AA`,
  },
};

export default config;
